import { render } from "./PaymentDetails.vue?vue&type=template&id=959dcb6a&scoped=true&lang=pug"
import script from "./PaymentDetails.vue?vue&type=script&lang=ts"
export * from "./PaymentDetails.vue?vue&type=script&lang=ts"

import "./PaymentDetails.vue?vue&type=style&index=0&id=959dcb6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-959dcb6a"

export default script